import routerOptions0 from "/builds/rialtic/qa/argocd-releases/console-ui/node_modules/.pnpm/nuxt@3.17.7_e5681f84b155a7df1c8e413b4044effb/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}